import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2, Plus } from "lucide-react";

const blank = { name: "", size: "", monthly_rate: 0, available: true, description: "" };

export default function AdminHangars() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState(blank);

  const load = () => api.get("/hangars").then((r) => setList(r.data));
  useEffect(() => { load(); }, []);

  const add = async () => {
    await api.post("/hangars", { ...form, monthly_rate: parseFloat(form.monthly_rate) || 0 });
    setForm(blank);
    load();
  };
  const del = async (id) => { await api.delete(`/hangars/${id}`); load(); };
  const toggle = async (h) => {
    await api.put(`/hangars/${h.id}`, { ...h, available: !h.available });
    load();
  };

  return (
    <div data-testid="admin-hangars">
      <div className="section-label">Inventory</div>
      <h1 className="font-display font-bold text-3xl text-slate-950 mt-2">Hangars</h1>

      <div className="mt-8 bg-white border border-slate-200 p-6 rounded-md">
        <div className="font-semibold text-slate-900 mb-3">Add new hangar</div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          <input data-testid="hangar-name" placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="border border-slate-300 px-3 py-2" />
          <input data-testid="hangar-size" placeholder="Size" value={form.size} onChange={(e) => setForm({ ...form, size: e.target.value })} className="border border-slate-300 px-3 py-2" />
          <input data-testid="hangar-rate" type="number" step="0.01" placeholder="Monthly $" value={form.monthly_rate} onChange={(e) => setForm({ ...form, monthly_rate: e.target.value })} className="border border-slate-300 px-3 py-2" />
          <button data-testid="hangar-add" onClick={add} className="bg-slate-950 text-white px-4 py-2 inline-flex items-center gap-2 justify-center"><Plus className="h-4 w-4" /> Add</button>
        </div>
        <input placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="mt-3 border border-slate-300 px-3 py-2 w-full" />
      </div>

      <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((h) => (
          <div key={h.id} data-testid={`admin-hangar-${h.id}`} className="bg-white border border-slate-200 p-5 rounded-md">
            <div className="font-display text-lg font-semibold">{h.name}</div>
            <div className="text-xs font-mono uppercase tracking-widest text-sky-600 mt-1">{h.size}</div>
            <div className="text-2xl font-display font-bold mt-3">${h.monthly_rate.toFixed(0)}/mo</div>
            <p className="text-sm text-slate-600 mt-2">{h.description}</p>
            <div className="mt-4 flex justify-between items-center">
              <button onClick={() => toggle(h)} className={`text-xs font-mono uppercase tracking-widest px-3 py-2 border ${h.available ? "border-emerald-500 text-emerald-700" : "border-slate-300 text-slate-500"}`}>
                {h.available ? "Available" : "Occupied"} · toggle
              </button>
              <button data-testid={`hangar-del-${h.id}`} onClick={() => del(h.id)} className="text-red-600 hover:text-red-800"><Trash2 className="h-4 w-4" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
